import React from 'react'
import { IntlProvider } from 'react-intl'

import type { WrapperProps } from '~/@types'
import type { Locale } from '~/common/@types'

import { LayoutSpinner } from '../components/LayoutSpinner'
import { useMessages } from './useMessages'

type IntlProps = WrapperProps & {
  locale?: Locale
}

const Intl: React.FC<IntlProps> = ({ children, locale }) => {
  const { data, error, loaded } = useMessages(locale)

  const handleIntlError = (e: unknown) => {
    if (import.meta.env.MODE === 'development' && loaded) {
      console.warn(e)
    }
  }

  if (error) {
    throw error
  }

  return (
    <IntlProvider messages={data} locale={locale || ''} onError={handleIntlError}>
      {data ? children : <LayoutSpinner />}
    </IntlProvider>
  )
}

export default Intl
